// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2TAw3","footer":"ModalFilter_footer__2E4iH"};